import React, { useEffect, useState } from "react";
import { List, X, PhoneCall } from "@phosphor-icons/react";
import Logo from "./Logo";
import { NAV_LINKS, COMPANY } from "@/lib/siteData";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-nav py-3" : "py-5 bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 flex items-center justify-between gap-6">
        <Logo />

        {/* Desktop nav */}
        <nav
          className="hidden lg:flex items-center gap-9"
          aria-label="Primary"
          data-testid="desktop-nav"
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="red-underline text-[13px] font-bold tracking-[0.18em] uppercase text-white/85 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* CTA + mobile */}
        <div className="flex items-center gap-3">
          <a
            href={`tel:${COMPANY.phoneRaw}`}
            data-testid="nav-phone-link"
            className="hidden 2xl:inline-flex items-center gap-2 text-[12px] font-bold tracking-[0.2em] uppercase text-white/70 hover:text-white transition-colors whitespace-nowrap"
          >
            <PhoneCall size={16} weight="bold" className="text-[#c41e3a]" />
            {COMPANY.phone}
          </a>
          <a
            href="#contact"
            data-testid="nav-quote-button"
            className="group hidden sm:inline-flex items-center gap-2 bg-[#c41e3a] hover:bg-[#e62244] text-white font-bold tracking-[0.22em] uppercase text-[11px] px-5 py-3 transition-colors whitespace-nowrap"
          >
            Get Quote
            <span className="inline-block w-3 h-[2px] bg-white transition-all group-hover:w-5" />
          </a>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            data-testid="mobile-menu-toggle"
            className="lg:hidden w-10 h-10 inline-flex items-center justify-center border border-white/15 text-white hover:bg-[#c41e3a] hover:border-[#c41e3a] transition-colors"
          >
            {open ? <X size={18} weight="bold" /> : <List size={18} weight="bold" />}
          </button>
        </div>
      </div>

      {/* Mobile panel */}
      {open && (
        <div
          data-testid="mobile-nav-panel"
          className="lg:hidden glass-nav mt-3 mx-5 border border-white/10"
        >
          <nav className="flex flex-col py-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                className="px-6 py-3 text-[13px] font-bold tracking-[0.18em] uppercase text-white/85 hover:text-[#c41e3a] hover:bg-white/5 transition-colors border-b border-white/5 last:border-0"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mx-6 mt-3 mb-4 bg-[#c41e3a] hover:bg-[#e62244] text-white text-center font-bold tracking-[0.22em] uppercase text-[11px] py-3 transition-colors"
            >
              Get Quote
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
